<template>
  <div class="damage f fcol gap16 card card-dark">
    <div class="card damage-map">
      <div class="card-body">
        <slot name="damageMap" />
      </div>
    </div>
    <div class="damage_info">
      <div class="card damage-range">
        <slot name="damageRange" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss">
@use './_vars.scss' as *;
@use '@/assets/scss/variables.scss' as *;

.damage {
  position: relative;
  @media screen and (max-width: 979px) {
    gap: 0.8rem;
  }

  .small {
    max-width: 25rem;
    width: 25rem;
  }

  &-map {
    padding: 0 0 2.4rem !important;
    overflow: hidden;

    @media screen and (max-width: 979px) {
      padding: 1.6rem 0 !important;
    }

    .card-body {
      display: flex;
      justify-content: center;
      min-height: $damage-map-image-container-height;
    }
  }

  &-range {
    width: 100%;
  }
}

.damage_info_body {
  min-height: $damage-char-number-of-items * $damage-char-item-height +
    ($damage-char-number-of-items - 1) * $damage-char-item-gap;
}

@media screen and (max-width: 600px) {
  .damage {
    display: block;

    .small {
      width: 100%;
      max-width: 100%;
    }

    &_info {
      display: flex;
      flex-wrap: wrap;
    }

    &-char {
      order: 1;
    }
  }
}
</style>
